import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";
import { useGetRawMaterialListQuery } from "../../../../store/api/bomapi";
import useKeyboardNavigation from "../../../../utils/useKeyboardNavigation";

const Table = ({ setselected_item_data,selected_item_data, po_status }) => {
  const createNewRow = () => ({
    item_code: "",
    item: {},
    quantity: 1,
    uom: "",
    rate: "0",
    amount: "0",
  });

  const tableRef = useRef();
  const dropdownRef = useRef();
  const [rowsPerPage] = useState(10);
  const [item_list, setitem_list] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rows, setRows] = useState([createNewRow()]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [search_input, setsearch_input] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });
  const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allRowIndices = rows.map((_, index) => index);
      setSelectedRows(allRowIndices);
    } else {
      setSelectedRows([]);
    }
  };
  useEffect(() => {
  if (selected_item_data && selected_item_data.length > 0) {
    setRows(selected_item_data);
  } else {
    setRows([createNewRow()]);
  }
}, [selected_item_data]);

  const { focusedCellkey, setFocusedCellkey } = useKeyboardNavigation(rows.length);

  const {data:rawMaterial} = useGetRawMaterialListQuery(`[["include_item_in_manufacturing","=",1],["is_fixed_asset","=",0],["Item","item_code","like","%${search_input}%"]]`);


  const filterItems = (searchText = "") => {
    if (!rawMaterial?.data) return [];
    return rawMaterial.data.filter(item => 
      item.item_code.toLowerCase().includes(searchText.toLowerCase()) ||
      item.item_name.toLowerCase().includes(searchText.toLowerCase())
    );
  };

  const updateRow = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    
    if (field === "quantity" || field === "rate") {
      const quantity = parseFloat(updatedRows[index].quantity) || 0;
      const rate = parseFloat(updatedRows[index].rate) || 0;
      updatedRows[index].amount = (quantity * rate).toFixed(0);
    }
    setRows(updatedRows);
    setselected_item_data(updatedRows);
  };

  const toggleRowSelection = (index) => {
    setSelectedRows((prev) => 
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const handleAddRow = () => {
    const newRows = [...rows, createNewRow()];
    setRows(newRows);
    setselected_item_data(newRows);
    const lastPage = Math.ceil(newRows.length / rowsPerPage);
    if (currentPage !== lastPage) {
      setCurrentPage(lastPage);
    }
  };

  const handleDeleteSelectedRows = () => {
    const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
    setRows(updatedRows);
    setselected_item_data(updatedRows);
    setSelectedRows([]);
    const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
    if (currentPage > lastPage) {
      setCurrentPage(lastPage);
    }
  };

  useEffect(() => {
    if (rawMaterial?.data) {
      setitem_list(rawMaterial.data);
    }
  }, [rawMaterial?.data]);

  useEffect(() => {
    const cols = tableRef.current?.querySelectorAll("th");
    if (!cols) return;
    
    cols.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, []);

  return (
    <div className="">
      <table className="table table-bordered mb-1" ref={tableRef}>
        <thead className="tableHead1">
          <tr>
            {["Action", "S.No", "Item Code", "Item Name", "Quantity", "UOM", "Rate", "Amount"].map((title, i) => {
              const defaultWidths = {
                "Action": "20px",
                "S.No": "20px",
                "Item Code": "110px",
                "Item Name": "220px",
                "Quantity": "8%",
                "UOM": "7%",
                "Rate": "100px",
                "Amount": "100px",
              };

              return (
                <th
                  key={i}
                  style={{
                    fontSize: '7px',
                    position: "relative",
                    textAlign: title === "Action" || title === "S.No" ? "center" : "center",
                    width: defaultWidths[title] || "150px",
                    minWidth: defaultWidths[title] || "150px",
                  }}
                >
                  {title === "Action" ? (
                    <input
                      type="checkbox"
                      className="form-check-input"
                      style={{ 
                        backgroundColor: isAllSelected ? "#270b79" : "", 
                        borderColor: isAllSelected ? "#270b79" : "", 
                        fontSize: '15px' 
                      }}
                      checked={isAllSelected}
                      onChange={handleSelectAll}
                    />
                  ) : (
                    title
                  )}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {currentRows.map((row, index) => {
            const globalIndex = indexOfFirstRow + index;
            return (
              <tr key={globalIndex}>
                <td className="p-0" style={{ cursor: 'pointer' }}>
                  <p className="m-0" style={{ position: 'relative', top: "5px" }}>
                    {selectedRows.includes(globalIndex) ? (
                      <span onClick={() => toggleRowSelection(globalIndex)}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          style={{ 
                            backgroundColor: "#270b79", 
                            fontSize: '15px', 
                            borderColor: '#270b79' 
                          }}
                          checked
                        />
                      </span>
                    ) : (
                      <span onClick={() => toggleRowSelection(globalIndex)}>
                        <input 
                          type="checkbox" 
                          className="form-check-input" 
                          style={{ fontSize: '15px' }} 
                        />
                      </span>
                    )}
                  </p>
                </td>
                <td style={{
                  textAlign: "center",
                  fontSize: '0.8rem',
                  padding: '0.5rem'
                }}>
                  {globalIndex + 1}
                </td>
                <td 
                  className="p-0 d-flex justify-content-center" 
                  style={{ 
                    position: "relative", 
                    border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'item_code' ? '0.3px solid #270b79' : '' 
                  }}
                >
                  <input
                    type="text"
                    className="form-control tableinput noborder"
                    style={{ fontSize: '0.8rem',textAlign:"center" }}
                    onFocus={() => { 
                      setShowDropdown(globalIndex); 
                      setFocusedCell({ rowIndex: globalIndex, field: 'item_code' });
                      if (!row.item_code && !row.item.item_code) {
                        setsearch_input("");
                        setitem_list(rawMaterial?.data || []);
                      }
                    }}
                    onBlur={() => setTimeout(() => setShowDropdown(false), 300)}
                    onChange={(e) => {
                      setsearch_input(e.target.value);
                      const filteredItems = filterItems(e.target.value);
                      setitem_list(filteredItems);
                      updateRow(globalIndex, "item_code", e.target.value);
                    }}
                    value={row.item.item_code || row.item_code}
                  />
                  {showDropdown === globalIndex && (
                    <div
                      ref={dropdownRef}
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        maxHeight: "200px",
                        overflowY: "auto",
                        background: "white",
                        border: "1px solid #ccc",
                        zIndex: 10,
                      }}
                    >
                      {item_list.length > 0 ? (
                        item_list.map((item, idx) => (
                          <div 
                            key={idx}
                            className="text-start"
                            onClick={() => {
                              updateRow(globalIndex, "item", item);
                              updateRow(globalIndex, "item_code", item.item_code);
                              updateRow(globalIndex, "uom", item.stock_uom);
                              setsearch_input("");
                              setShowDropdown(false);
                            }}
                            style={{
                              padding: "8px",
                              cursor: "pointer",
                              borderBottom: "1px solid #eee",
                            }}
                          >
                            <p className="m-0">{item.item_code}</p>
                            <div style={{ fontSize: '10px' }}>{item.item_name}</div>
                          </div>
                        ))
                      ) : (
                        <div style={{ padding: "8px", color: "#888" }}>No results found</div>
                      )}
                    </div>
                  )}
                </td>
                <td className="p-0">
                  <input 
                    type="text" 
                    className="form-control tableinput noborder" 
                    style={{ fontSize: '0.8rem',textAlign:'center' }} 
                    readOnly 
                    value={row.item.item_name || ""} 
                  />
                </td>
                <td className="p-0 d-flex justify-content-center" 
                    style={{ 
                      border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'quantity' ? '0.3px solid #270b79' : '' 
                    }}
                >
                  <input 
                    type="tel" 
                    className="form-control tableinput noborder" 
                    style={{ fontSize: '0.8rem',textAlign:"center" }} 
                    min={1} 
                    data-rowindex={globalIndex}
                    data-field={"quantity"}
                    onFocus={() => {setFocusedCell({ rowIndex: globalIndex, field: 'quantity' });setFocusedCellkey({ rowIndex:globalIndex, field:'quantity' })}}
                    onBlur={() => {setFocusedCell({ rowIndex: null, field: null });setFocusedCellkey({ rowIndex: null, field: null })}} 
                    value={row.quantity} 
                     onChange={(e) => {
                      const value = parseInt(e.target.value);
                      if (/^\d*$/.test(value)) {
                        updateRow(globalIndex, "quantity", value);
                      }
                    }}
                    // onChange={(e) => {
                    //   const value = parseInt(e.target.value);
                    //   if (value >= 1 || e.target.value === '') {
                    //     updateRow(globalIndex, "quantity", e.target.value);
                    //   }
                    // }} 
                  />
                </td>
                <td className="p-0">
                  <input 
                    type="text" 
                    className="form-control tableinput noborder" 
                    style={{ fontSize: '0.8rem',textAlign:"center" }} 
                    readOnly 
                    value={row.item.stock_uom || row.uom || ""} 
                  />
                </td>
                <td className="p-0">
                  <input 
                    type="text" 
                    className="form-control tableinput noborder" 
                    style={{ fontSize: '0.8rem',textAlign:"center" }} 
                    value={`₹${row.rate}`} 
                    onChange={(e) => updateRow(globalIndex, "rate", e.target.value)}
                  />
                </td>
                <td className="p-0">
                  <input 
                    type="text" 
                    className="form-control tableinput noborder" 
                    style={{ fontSize: '0.8rem',textAlign:"center" }} 
                    readOnly 
                    value={row.amount ? `₹${row.amount}` : ""} 
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="d-flex pb-2 justify-content-between align-items-center">
        <div className="d-flex" style={{ gap: '4px' }}>
          {selectedRows.length > 0 && po_status === '' && (
            <Button
              onClick={handleDeleteSelectedRows}
              className="customdeletebtn"
              iconName="MdDeleteOutline"
              iconSize={12}
            >
              Delete
            </Button>
          )}
          {selectedRows.length === 0 && po_status === '' && (
            <Button
              onClick={handleAddRow}
              className="Addrowdesign"
              iconName="FiPlus"
              iconSize={12}
              iconWrapperStyle={{ 
                backgroundColor: '#ff8d5c', 
                padding: '1px', 
                display: 'flex' 
              }}
            >
              Add Row
            </Button>
          )}
          <Button
            className="createbtn d-flex"
            style={{ gap: '2px', height: '28px' }}
            iconName="MdOutlineFileDownload"
            iconSize={12}
          >
            Download
          </Button>
        </div>

        {rows.length >= 11 && (
          <>
            <div className="d-flex align-items-center centerpagination" style={{ gap: '5px' }}>
              <Pagination
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
                pageSize={rowsPerPage}
                totalrecords={rows.length}
              />
            </div>
            <div>
              <span className="px-2" style={{ fontSize: '12px', color: '#270B79' }}>
                Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
              </span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Table;